import React, { Component } from 'react'
import tick from '../../static/images/tick.gif'

export class CustomModal extends Component {
    render() {
        return (
            <div className="sh-custom-modal-comp" onClick={()=>{this.props.closeModal()}}>
                <div className="sh-gnrl-modal-inner" onClick={(e)=>e.stopPropagation()}>
                    <div className="sh-gnrl-modal">
                        <div className="sh-gnrl-modal-image">
                            <img src={tick} alt=""/>
                        </div>
                        
                        <div className="sh-gnrl-modal-heading">
                            <h2 className="sh-gnrl-mh2 sh-mb-10">All set!</h2>
                        </div>
                        
                        <div className="sh-gnrl-modal-content">
                            <p className="sh-gnrl-mc">Your password has been changed</p>
                        </div>

                    </div>
                    


                </div>
            </div>
        )
    }
}

export default CustomModal



// WEBPACK FOOTER //
// ./src/components/CutomModal/index.js